import { render, staticRenderFns } from "./ReporteNovedadesHSEDinamico.vue?vue&type=template&id=24731b52"
import script from "./ReporteNovedadesHSEDinamico.vue?vue&type=script&lang=js"
export * from "./ReporteNovedadesHSEDinamico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports